<template>
  <b-container fluid="lg" class="h-100">
    <b-row class="row h-100">
      <b-col class="my-auto">
        <b-row class="steps-tunnel steps-tunnel-forgot-password w-50">
          <!-- step1 btn -->
          <b-col cols="auto step-btn-block">
            <div class="step-text">Votre nom d'utilisateur</div>
            <b-button
              class="button btn-step"
              :class="{
                'btn-step-active': currentStep == 1,
                'btn-step-passed': currentStep == 2 || currentStep == 3,
              }"
            >
              1
            </b-button>
          </b-col>
          <b-col class="step-line"></b-col>
          <!-- step2 btn -->
          <b-col cols="auto step-btn-block">
            <div class="step-text">Code de validation</div>
            <b-button
              class="button btn-step"
              :class="{ 'btn-step-active': currentStep == 2, 'btn-step-passed': currentStep == 3 }"
              :disabled="!step1ok"
            >
              2
            </b-button>
          </b-col>
          <b-col class="step-line"></b-col>
          <!-- step3 btn -->
          <b-col cols="auto step-btn-block">
            <div class="step-text">Mot de passe</div>
            <b-button
              class="button btn-step"
              :class="{ 'btn-step-active': currentStep == 3 }"
              :disabled="!step2ok"
            >
              3
            </b-button>
          </b-col>
        </b-row>
        <!-- .. -->
        <div>
          <b-form>
            <appStep1
              v-if="currentStep == 1"
              ref="step-1"
              :object="object"
              @updateObject="updateObject"
            />
            <appStep2
              v-if="currentStep == 2"
              ref="step-2"
              :object="object"
              @updateObject="updateObject"
            />
            <appStep3
              v-if="currentStep == 3"
              ref="step-3"
              :object="object"
              @updateObject="updateObject"
            />

            <b-row class="justify-content-center my-2">
              <b-col cols="10" sm="7">
                <b-alert :show="error" variant="danger">Sorry, something went wrong.</b-alert>
                <b-alert :show="errorStep1NoUser" variant="danger">User does not exist.</b-alert>
                <b-alert :show="errorStep1NoEmail" variant="danger">
                  User does not have email.
                </b-alert>
                <b-alert :show="errorStep2Invalid" variant="danger">
                  Verification code is invalid.
                </b-alert>
                <b-alert :show="errorStep2Expired" variant="danger">
                  Verification code expired.
                </b-alert>
                <b-alert :show="errorStep3" variant="danger">ERROR</b-alert>
              </b-col>
            </b-row>

            <!-- cancel, create, update -->
            <b-row class="mt-5 mb-2 justify-content-center">
              <b-col cols="auto">
                <b-button class="button btn-danger" :to="{ name: 'login' }">
                  <font-awesome-icon icon="arrow-left" />
                  <span class="ml-2">Retour à la connexion</span>
                </b-button>
              </b-col>
              <b-col cols="auto">
                <b-button
                  :disabled="isLoadingNext"
                  type="submit"
                  class="button btn-blue"
                  @click.prevent="goToNextStep"
                >
                  <span v-if="currentStep !== 3" class="mr-2">Continuer</span>
                  <span v-else class="mr-2">Enregistrer</span>
                  <font-awesome-icon v-if="!isLoadingNext" icon="arrow-right" />
                  <font-awesome-icon v-else icon="spinner" pulse />
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { validate } from "vee-validate";

import appStep1 from "@/components/ForgotPassword/Step1";
import appStep2 from "@/components/ForgotPassword/Step2";
import appStep3 from "@/components/ForgotPassword/Step3";

export default {
  components: {
    appStep1,
    appStep2,
    appStep3,
  },
  data() {
    return {
      currentStep: 1,
      step1ok: false,
      step2ok: false,
      isLoadingNext: false,
      error: false,
      errorStep1NoUser: false,
      errorStep1NoEmail: false,
      errorStep2Invalid: false,
      errorStep2Expired: false,
      errorStep3: false,
      object: {
        username: "",
        verificationCode: "",
        // hash: "", // ???: ..
        password: "",
        passwordConfirm: "",
      },
    };
  },
  mounted() {
    // EX: position steps tunnel texts
    this.setStepTextsStyles();
  },
  methods: {
    updateObject(key, value) {
      this.object[key] = value;
    },
    async validateStep() {
      var valid = true;
      if (this.currentStep == 1) {
        await validate(this.object.username, "required", {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-1"].$refs["vee-username"].validate();
          }
        });
      }
      if (this.currentStep == 2) {
        await validate(this.object.verificationCode, "required", {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-2"].$refs["vee-verificationCode"].validate();
          }
        });
      }
      if (this.currentStep == 3) {
        await this.$refs["step-3"].$refs["vee-password"].validate().then(res => {
          if (!res) {
            valid = false;
          }
        });
      }
      return valid;
    },
    async goToNextStep() {
      if ((await this.validateStep()) == false) {
        return;
      }

      if (this.currentStep == 1) {
        this.CHECK_USERNAME();
      } else if (this.currentStep == 2) {
        this.CHECK_VERIFICATION_CODE();
      } else {
        this.SET_PASSWORD();
      }
    },
    async CHECK_USERNAME() {
      this.isLoadingNext = true;

      this.errorStep1NoUser = false;
      this.errorStep1NoEmail = false;
      this.error = false;

      this.$store
        .dispatch("auth/checkUsername", this.object.username)
        .then(() => {
          this.isLoadingNext = false;
          this.step1ok = true;
          this.currentStep++;
        })
        .catch(err => {
          this.isLoadingNext = false;
          console.error(err);

          if (err.response) {
            if (err.response.data["hydra:description"] == "User does not exist") {
              this.errorStep1NoUser = true;
              return;
            } else if (err.response.data["hydra:description"] == "User does not have email") {
              this.errorStep1NoEmail = true;
              return;
            }
          }
          this.error = true;
        });
    },
    async CHECK_VERIFICATION_CODE() {
      this.isLoadingNext = true;

      this.errorStep2Invalid = false;
      this.errorStep2Expired = false;
      this.error = false;

      this.$store
        .dispatch("auth/checkVerificationCode", this.object.verificationCode)
        .then(() => {
          this.isLoadingNext = false;
          this.step2ok = true;
          this.currentStep++;
        })
        .catch(err => {
          this.isLoadingNext = false;
          console.error(err);

          if (err.response.data["hydra:description"] == "Verification code invalid") {
            this.errorStep2Invalid = true;
            return;
          } else if (err.response.data["hydra:description"] == "Verification code expired") {
            this.errorStep2Expired = true;
            return;
          }
          this.error = true;
        });
    },
    async SET_PASSWORD() {
      this.isLoadingNext = true;

      this.errorStep3 = false;

      this.$store
        .dispatch("auth/setPassword", {
          verificationCode: this.object.verificationCode,
          password: this.object.password,
        })
        .then(res => {
          this.isLoadingNext = false;
          this.$router.push({ name: "login" });
        })
        .catch(err => {
          this.isLoadingNext = false;
          console.error(err);

          this.errorStep3 = true;
        });
    },
  },
};
</script>
